import { render } from "./SyncDialog.vue?vue&type=template&id=465db0f0"
import script from "./SyncDialog.vue?vue&type=script&lang=js"
export * from "./SyncDialog.vue?vue&type=script&lang=js"

import "./SyncDialog.vue?vue&type=style&index=0&id=465db0f0&lang=scss"
script.render = render

export default script